@if (showTextarea()) {
  <textarea
    class="answer-input"
    placeholder="Add your response..."
    aria-label="Add your response"
    [formControl]="answerControl"
    [dataSelector]="'cxp-crl-panel-answer'"
    (input)="onInput()"
    (focus)="onFocus()"
    (blur)="onBlur()"
  ></textarea>
} @else {
  <p class="answer-text">{{ item().answer }}</p>
}
